module.exports = __webpack_public_path__ + "img/icon_emitter.2591218e.jpg";